import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=b82379ae&scoped=true&lang=pug&"
import script from "./VLink.vue?vue&type=script&lang=js&"
export * from "./VLink.vue?vue&type=script&lang=js&"
import style0 from "./VLink.vue?vue&type=style&index=0&id=b82379ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82379ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b82379ae')) {
      api.createRecord('b82379ae', component.options)
    } else {
      api.reload('b82379ae', component.options)
    }
    module.hot.accept("./VLink.vue?vue&type=template&id=b82379ae&scoped=true&lang=pug&", function () {
      api.rerender('b82379ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/VLink.vue"
export default component.exports